import {
  UPLOAD_STORAGE_KEY,
  activeCaseCode,
  readItemsForCase,
} from "./case-scoped-storage";

const loadUploads = () => readItemsForCase(UPLOAD_STORAGE_KEY, activeCaseCode());

const UploadResilienceHook = {
  mounted() {
    this.statusEl = this.el.querySelector("[data-upload-status]");
    this.detailEl = this.el.querySelector("[data-upload-detail]");

    this.update = () => {
      const uploads = loadUploads();
      const failed = uploads.filter((upload) => upload.status === "failed").length;
      const retrying = uploads.filter((upload) => upload.status === "retrying").length;
      const uploading = uploads.filter((upload) => upload.status === "uploading").length;
      const online = navigator.onLine;

      if (!this.statusEl) return;

      if (!online) {
        this.statusEl.textContent = "Offline. Uploads will retry when you reconnect.";
      } else if (failed > 0) {
        this.statusEl.textContent = `${failed} upload(s) need retry.`;
      } else if (retrying > 0) {
        this.statusEl.textContent = `Retrying ${retrying} upload(s)...`;
      } else if (uploading > 0) {
        this.statusEl.textContent = `Uploading ${uploading} file(s)...`;
      } else {
        this.statusEl.textContent = "Uploads are stable.";
      }

      if (this.detailEl) {
        this.detailEl.textContent =
          failed > 0
            ? "Reopen the uploader to retry failed files."
            : "You can close this window and uploads will continue in the background.";
      }
    };

    this.update();

    window.addEventListener("online", this.update);
    window.addEventListener("offline", this.update);
    window.addEventListener("uploads:updated", this.update);
  },
  destroyed() {
    window.removeEventListener("online", this.update);
    window.removeEventListener("offline", this.update);
    window.removeEventListener("uploads:updated", this.update);
  },
};

export default UploadResilienceHook;
